






import React from "react"
import { PageTemplate } from "./page_template"

export function Page0() {
    return <PageTemplate>
        <div className="page-section">
            <h2> CREATE NODES </h2>
            <div className="row">
                <span className="text">
                    NUNISYNTH's nodes can be accessed from the context-menu.
                    The nodes range in complexity from simple oscillator, to
                    multi-sample piano roll, to custom audio processor.
                </span>
                <div className="contextmenu-pic shadow"></div>
            </div>
        </div>

        <div className="page-section">
            <h2 className="center"> CREATE SAMPLES </h2>
            <span className="text _2a">
                Create new samples from microphone recordings, desktop recordings, or
                formulas.
            </span>
            <div className="flex-center">
                <div className="samples-pic"></div>
                <div className="samples-pic _2"></div>
            </div>
        </div>
        
        <div className="page-section">
            <h2 className="center"> CREATE TUNINGS </h2>
            <div className="row center">
                <span className="text _2">
                    Create new scales by equally dividing octaves,
                    declaring lists of cents / Just Intonation ratios,
                    or with formulas.
                </span>
                <div className="tuning-pic shadow"></div>
            </div>
        </div>
    </PageTemplate>
}